import script from "./StepDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepDetails.vue?vue&type=script&setup=true&lang=ts"

import "./StepDetails.vue?vue&type=style&index=0&id=972b9582&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-972b9582"]])

export default __exports__